import React from "react";
import NormalButton from "component/common/NormalButton/NormalButton";
import { history } from "helpers";
import "./style.scss";

const NotFound = () => {
  const handleHomePage = () => {
    history?.push("/admin/dashboard");
  };

  return (
    <div className="notFound">
      <div className="notFound-box">
        <h1 className="oops-text pb-5">Oops!</h1>
        <b className="pb-3">404 - PAGE NOT FOUND</b>
        <span className="pb-3">
          Sorry about that, but the page you’re looking for is unknown or does
          not exist
        </span>
        <div className="row">
          <div className="col-12">
            {" "}
            <NormalButton
              onClick={handleHomePage}
              label={"Return Home"}
              className="orderBtn text-uppercase"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
